export type Craft = {
  id: string
  alt: string
  src: string
}

/** Carousel #1 — animals, ocean & fantasy creatures. Moves right-to-left. */
export const craftsAnimals: Craft[] = [
  {
    id: 'lion',
    alt: 'Finished paper craft lion made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4d27b970-307a-4649-bd81-36396e592cb5.jpg',
  },
  {
    id: 'elephant',
    alt: 'Finished paper craft elephant made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4707d52b-71e0-41b8-990b-a4faa3155cf9.jpg',
  },
  {
    id: 'giraffe',
    alt: 'Finished paper craft giraffe made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/1a435a1b-04ea-41ca-beda-37d75668f1af.jpg',
  },
  {
    id: 'shark',
    alt: 'Finished paper craft shark made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/50c92a1f-8f67-4dbe-8b4d-bd86b7c7e299.jpg',
  },
  {
    id: 'fox',
    alt: 'Finished paper craft fox made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/aa56f8ca-b517-4e06-860f-b168103bc3e9.jpg',
  },
  {
    id: 'dinosaur',
    alt: 'Finished paper craft stegosaurus made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/10a922c8-1f21-428d-93fd-975f03b33868.jpg',
  },
  {
    id: 'whale',
    alt: 'Finished paper craft whale made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a1d2eae3-e3f3-4faf-b60a-cfd1e16902c1.jpg',
  },
  {
    id: 'turtle',
    alt: 'Finished paper craft sea turtle made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/1640b7c8-6b31-4e1d-b8aa-69c388758aff.jpg',
  },
  {
    id: 'bird',
    alt: 'Finished paper craft bird made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/137d65b4-f960-4678-8d34-611d547d6a14.jpg',
  },
  {
    id: 'dragon',
    alt: 'Finished paper craft dragon made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2b2bd894-ba12-4d93-aa0e-ff0c1830cc8b.jpg',
  },
  {
    id: 'crocodile',
    alt: 'Finished paper craft crocodile made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6061ae0e-4947-48b8-b4e6-97f7956184a0.jpg',
  },
  {
    id: 'monkey',
    alt: 'Finished paper craft monkey made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/78093275-03ea-4f2d-b88d-0048f38077a5.jpg',
  },
  {
    id: 'cat',
    alt: 'Finished paper craft cat made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2c65d0e0-b60f-448c-8702-19dc95205fcf.jpg',
  },
  {
    id: 'dog',
    alt: 'Finished paper craft dog made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/586a8827-f894-49f0-a3d3-b1218d70a148.jpg',
  },
  {
    id: 'unicorn',
    alt: 'Finished paper craft unicorn made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8fa0cf17-756a-4484-bcad-2dd1fb618df8.jpg',
  },
]

/** Carousel #2 — vehicles, machines, robots & worlds. Moves left-to-right. */
export const craftsMachines: Craft[] = [
  {
    id: 'racecar',
    alt: 'Finished paper craft race car made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c61dcca1-e60a-48df-a032-36aab7eba301.jpg',
  },
  {
    id: 'truck',
    alt: 'Finished paper craft truck made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a385ff83-fb05-4142-b750-20ebbadf46c2.jpg',
  },
  {
    id: 'airplane',
    alt: 'Finished paper craft airplane made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4d77dd13-3511-4527-b989-195a0b95eb44.jpg',
  },
  {
    id: 'helicopter',
    alt: 'Finished paper craft helicopter made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/06808d08-42ac-4056-b5b1-687f9fc4d3aa.jpg',
  },
  {
    id: 'rocket',
    alt: 'Finished paper craft rocket made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7486c18f-d58f-408f-99e0-e34c98537b71.jpg',
  },
  {
    id: 'robot',
    alt: 'Finished paper craft robot made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8ebfc28f-436a-4e91-9702-9d52b6def420.jpg',
  },
  {
    id: 'castle',
    alt: 'Finished paper craft castle made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/393b3808-da29-446e-be45-22febb38a96a.jpg',
  },
  {
    id: 'house',
    alt: 'Finished paper craft house made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/dc1bd34f-8c08-4869-a4a4-50cddfef8703.jpg',
  },
  {
    id: 'spaceship',
    alt: 'Finished paper craft spaceship made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/47ae7037-c43f-4cec-bf5c-a6eaa0d6a939.jpg',
  },
  {
    id: 'pirateship',
    alt: 'Finished paper craft pirate ship made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d1c20e9f-8916-4087-b171-ce9da385b5cf.jpg',
  },
  {
    id: 'excavator',
    alt: 'Finished paper craft excavator made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/795d448f-39ad-415d-b78d-a7329feff2b6.jpg',
  },
  {
    id: 'mask',
    alt: 'Finished paper craft dragon mask made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e0c7aa06-c8a9-495e-92e8-d9dfd76baff5.jpg',
  },
  {
    id: 'creature',
    alt: 'Finished paper craft mythical creature made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7627eb41-d371-481b-ba23-67bcf2f25024.jpg',
  },
  {
    id: 'lighthouse',
    alt: 'Finished paper craft lighthouse made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ab61723e-fa7e-4ae4-9dcc-36374db4c878.jpg',
  },
  {
    id: 'village',
    alt: 'Finished paper craft miniature village made from printed cardstock',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4e733da7-0ff1-4a77-84dd-a0cd22b7cbf7.jpg',
  },
  {
    id: 'template-tree',
    alt: 'Printable template sheet for a 3D paper Christmas tree, showing cut lines, fold lines and assembly steps',
    src: 'https://cdn.magicpatterns.com/uploads/9tntbV6AZdGR1n75Akju4F/IMG_8318.webp',
  },
  {
    id: 'template-letters',
    alt: 'Printable template sheet for 3D paper letters A, B, C and D, showing cut lines, fold lines and assembly steps',
    src: 'https://cdn.magicpatterns.com/uploads/xjaejidfv7WC9EMBfHtQwt/IMG_8320.webp',
  },
]
